module.exports = __webpack_public_path__ + "img/email.5b7107e0.svg";